import { render } from "./TitlePage.vue?vue&type=template&id=88946e56&scoped=true"
import script from "./TitlePage.vue?vue&type=script&lang=js"
export * from "./TitlePage.vue?vue&type=script&lang=js"

import "./TitlePage.vue?vue&type=style&index=0&id=88946e56&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88946e56"]])

export default __exports__